import React, { useState, useEffect } from 'react';
import { Row, Col, Select, Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import Cookies from 'js-cookie';
import { DiffChecker_URL } from '../../Components/Constant';

const { Option } = Select;

const SelectSourceAndDestination = ({ parentCallback, sourceSelection, destinationSelection, comparejouney }) => {
    const [inputValue, setInputValue] = useState('');
    const [inputValue2, setInputValue2] = useState('');
    const [accounts, setAccounts] = useState([]);

  
    useEffect(() => {
        const fetchAccounts = async () => {
            const token = Cookies.get('tokenRes');
            try {
                const response = await axios.get(`${DiffChecker_URL}/query/allUsers`, {
                    headers: {
                        JWTToken: token,
                    },
                });
                setAccounts(response.data);
            } catch (error) {
                console.error('Error fetching accounts:', error);
            }
        };

        fetchAccounts();
    }, []);

    const handleSourceChange = (value) => {
        setInputValue(value);
        setInputValue2('');
        const selected = accounts.find((acc) => acc.Id === value);
        parentCallback(selected, destinationSelection);
    };

    const handleDestinationChange = (value) => {
        setInputValue2(value);
        setInputValue('');
        const selected = accounts.find((acc) => acc.Id === value);
        parentCallback(sourceSelection, selected);
    };

    const handleSourceSearch = (value) => {
        setInputValue(value);
    };

    const handleDestinationSearch = (value) => {
        setInputValue2(value);
    };

    return (
        <Row gutter={16}>
            {/* Source Select */}
            <Col flex={1}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ marginBottom: 4 }}>Source</span>
                    <Select
                        showSearch
                        placeholder="Select Source"
                        value={sourceSelection?.Id}
                        disabled={comparejouney?._id || comparejouney?.id}
                        onChange={handleSourceChange}
                        onSearch={handleSourceSearch}
                        filterOption={(input, option) =>
                            option.children.props.children[1]
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        style={{ width: '100%' }}
                        allowClear
                    >
                        {accounts.map((account) => (
                            <Option key={account.Id} value={account.Id}>
                                <Space>
                                    <UserOutlined />
                                    {account.Name}
                                </Space>
                            </Option>
                        ))}
                    </Select>
                </div>
            </Col>

            {/* Destination Select */}
            <Col flex={1}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ marginBottom: 4 }}>Destination</span>
                    <Select
                        showSearch
                        placeholder="Select Destination"
                        value={destinationSelection?.Id}
                        disabled={comparejouney?._id || comparejouney?.id}
                        onChange={handleDestinationChange}
                        onSearch={handleDestinationSearch}
                        filterOption={(input, option) =>
                            option.children.props.children[1]
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        style={{ width: '100%' }}
                        allowClear
                    >
                        {accounts.map((account) => (
                            <Option key={account.Id} value={account.Id}>
                                <Space>
                                    <UserOutlined />
                                    {account.Name}
                                </Space>
                            </Option>
                        ))}
                    </Select>
                </div>
            </Col>
        </Row>
    );
};

export default SelectSourceAndDestination;
